// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bH5mo","containerInner":"styles_containerInner__FUd1O","dialog":"styles_dialog__JGfXg"};